import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';
import { WsButton } from 'wisestep-base';

interface IAddEntityButton {
  buttonText: string;
  onClick: () => void;
  justifyContent?: string;
}

const AddEntityButton = ({ buttonText, onClick, justifyContent }: IAddEntityButton) => (
  <Grid item xs={12} pt={2} pb={2} container justifyContent={justifyContent ?? ''}>
    <WsButton startIcon={<AddIcon fontSize="small" />} onClick={onClick}>
      {buttonText}
    </WsButton>
  </Grid>
);

export default AddEntityButton;
